import { isFuture, isPast } from 'date-fns';
import { delay } from 'redux-saga/effects';

import { Capability, Entitlement } from 'store/user/reducer.types';

import debugLog from 'utils/debugLog.ts';

export enum RequestStatus {
    IDLE = 'IDLE',
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    FAILURE = 'FAILURE',
    RETRYING = 'RETRYING',
}

export function requestPending(status: RequestStatus) {
    return status === RequestStatus.PENDING;
}

export function requestSuccess(status: RequestStatus) {
    return status === RequestStatus.SUCCESS;
}

export function requestFailure(status: RequestStatus) {
    return status === RequestStatus.FAILURE;
}

export function requestIdle(status: RequestStatus) {
    return status === RequestStatus.IDLE;
}

export function requestRetrying(status: RequestStatus) {
    return status === RequestStatus.RETRYING;
}

export function injectReducer(initialState: any, handlers: any) {
    if (__DEV__) {
        if (handlers.undefined) {
            console.warn(
                "Reducer contains an 'undefined' action type. Have you misspelled a constant?",
            );
        }
    }

    return (state = initialState, action: any) => {
        const $state = state === undefined ? initialState : state;

        // eslint-disable-next-line no-prototype-builtins
        if (action && handlers.hasOwnProperty(action.type)) {
            return handlers[action.type]($state, action);
        }

        return $state;
    };
}

export function isCapabilityValid(
    capability: Capability | Entitlement | undefined,
) {
    if (capability) {
        const validFromDate = new Date(capability.validFrom);
        const expiryDate = new Date(capability.expiryDate);

        return isPast(validFromDate) && isFuture(expiryDate);
    }

    return false;
}

export function* delayRetryRequest(
    attempt: number,
    retryCount: number,
    retryDuration: number,
) {
    if (attempt > 0) {
        const baseInterval = retryDuration / retryCount;

        const jitteredDelay = Math.floor(Math.random() * baseInterval);

        debugLog(
            'delayRetryRequest',
            `delay of ${jitteredDelay}ms before ${attempt} retry attempt`,
        );

        yield delay(jitteredDelay);
    }
}
